export const AWS_ACTIVATE_HERO_STATS = [
  { icon: "bi-shield-check", label: "AWS Activate Provider" },
  { icon: "bi-currency-dollar", label: "Up to $100,000 Credits Available" },
  { icon: "bi-award", label: "AWS Certified Consultants" },
  { icon: "bi-lightning-charge", label: "Fast Application Support" },
];

export const AWS_ELIGIBILITY = [
  {
    icon: "bi-calendar3",
    title: "Startup Age",
    desc: "Your startup should be less than 10 years old from the date of incorporation.",
    badge: "Required",
  },
  {
    icon: "bi-building",
    title: "Private Company",
    desc: "Must be a privately held company and not listed on any public stock exchange.",
    badge: "Required",
  },
  {
    icon: "bi-globe2",
    title: "New AWS Account",
    desc: "Should not have previously received AWS Activate credits from another provider.",
    badge: "Eligible Requirement",
  },
  {
    icon: "bi-link-45deg",
    title: "Company Website",
    desc: "A live company website or product landing page is required for verification.",
    badge: "Required",
  },
  {
    icon: "bi-briefcase",
    title: "Business Model",
    desc: "Must have a scalable technology-driven product or platform business model.",
    badge: "Required",
  },
  {
    icon: "bi-file-earmark-text",
    title: "Valid Documents",
    desc: "Company registration certificate and founder identification documents required.",
    badge: "Required",
  },
];

export const AWS_BENEFITS = [
  {
    icon: "bi-cash-stack",
    title: "AWS Credit Support",
    desc: "Get guidance to access AWS Activate credits worth up to $100,000 for your startup infrastructure.",
  },
  {
    icon: "bi-diagram-3",
    title: "Cloud Architecture Consultation",
    desc: "Expert review of your cloud architecture to optimize performance, security, and cost.",
  },
  {
    icon: "bi-graph-down-arrow",
    title: "Cost Optimization",
    desc: "Reduce cloud spend with right-sizing, reserved instances, and usage monitoring strategies.",
  },
  {
    icon: "bi-shield-lock",
    title: "Security Recommendations",
    desc: "Implement AWS security best practices including IAM, encryption, and compliance controls.",
  },
  {
    icon: "bi-speedometer2",
    title: "Performance Optimization",
    desc: "Improve application speed and reliability with AWS-native performance tuning.",
  },
  {
    icon: "bi-headset",
    title: "Dedicated Support",
    desc: "Personalized onboarding and ongoing support from Emicron's AWS-certified team.",
  },
];

export const AWS_PROCESS_STEPS = [
  {
    icon: "bi-pencil-square",
    title: "Complete Application",
    desc: "Fill out the multi-step application form with your startup and AWS account details.",
  },
  {
    icon: "bi-search",
    title: "Reviews Eligibility",
    desc: "Our team reviews your startup profile against AWS Activate eligibility criteria.",
  },
  {
    icon: "bi-folder-check",
    title: "Document Verification",
    desc: "We verify your company registration, founder ID, and supporting documents.",
  },
  {
    icon: "bi-send",
    title: "Submitted to AWS",
    desc: "Your verified application is submitted to AWS through Emicron as your Activate provider.",
  },
  {
    icon: "bi-hourglass-split",
    title: "AWS Evaluates",
    desc: "AWS reviews your application and determines the credit package for your startup.",
  },
  {
    icon: "bi-check-circle",
    title: "Credits Issued",
    desc: "Upon approval, AWS Activate credits are issued directly to your AWS account.",
  },
];

export const AWS_WHY_EMICRON = [
  { icon: "bi-person-check", title: "Personalized Onboarding" },
  { icon: "bi-layers", title: "Infrastructure Planning" },
  { icon: "bi-people", title: "Experienced Cloud Consultants" },
  { icon: "bi-shield-check", title: "Security Recommendations" },
  { icon: "bi-piggy-bank", title: "Cost Optimization Guidance" },
  { icon: "bi-gear", title: "DevOps Best Practices" },
  { icon: "bi-graph-up", title: "Scalability Planning" },
  { icon: "bi-clock-history", title: "Ongoing Support" },
];

export const AWS_FAQS = [
  {
    q: "What is AWS Activate?",
    a: "AWS Activate is a program that provides startups with AWS credits, technical support, and training to help them build and scale on AWS infrastructure.",
  },
  {
    q: "How much credit can my startup receive?",
    a: "Eligible startups can receive up to $100,000 in AWS credits depending on their stage, funding status, and AWS evaluation.",
  },
  {
    q: "Who is eligible for AWS Activate?",
    a: "Privately held startups less than 10 years old with a technology product, valid website, and no prior AWS Activate credits from another provider.",
  },
  {
    q: "How long does the application process take?",
    a: "Typically 2–4 weeks after submitting a complete application with all required documents.",
  },
  {
    q: "What documents are required?",
    a: "Company registration certificate, founder government ID, company website URL, and AWS account details.",
  },
  {
    q: "Can I apply if I already use AWS?",
    a: "Yes, but you must not have previously received AWS Activate credits through another Activate provider.",
  },
  {
    q: "Is there a fee to apply through Emicron?",
    a: "No, Emicron provides AWS Activate application support at no cost to eligible startups.",
  },
  {
    q: "What happens after credits are issued?",
    a: "Credits are applied to your AWS account. Emicron continues to support you with architecture, security, and cost optimization.",
  },
];

export const AWS_MORE_SERVICES = [
  { icon: "bi-cloud-arrow-up", label: "Cloud Migration" },
  { icon: "bi-gear-wide-connected", label: "DevOps Consulting" },
  { icon: "bi-arrow-repeat", label: "Disaster Recovery" },
  { icon: "bi-shield-lock", label: "Cloud Security" },
  { icon: "bi-database", label: "Database Services" },
  { icon: "bi-bar-chart", label: "Data Analytics" },
  { icon: "bi-hdd-network", label: "Managed Services" },
  { icon: "bi-headset", label: "24×7 Support" },
];

export const AWS_FORM_STEPS = [
  "Company Information",
  "Contact Details",
  "AWS Account Details",
  "Provider & Application Details",
  "Document Checklist",
  "Review & Submit",
];

export const AWS_DOCUMENT_CHECKLIST = [
  "Company Registration Certificate",
  "Founder Government ID",
  "Company Website URL",
  "AWS Account ID Proof",
  "Pitch Deck (Optional)",
  "Funding Documentation (If applicable)",
];

export const AWS_INDUSTRY_OPTIONS = [
  "SaaS / Software",
  "FinTech",
  "HealthTech",
  "EdTech",
  "E-Commerce",
  "AI / ML",
  "IoT",
  "Other",
];

export const AWS_TEAM_SIZE_OPTIONS = ["1–5", "6–10", "11–25", "26–50", "51–100", "100+"];

export const AWS_STARTUP_STAGE_OPTIONS = [
  "Idea / Pre-seed",
  "Seed",
  "Series A",
  "Series B+",
  "Bootstrapped",
];

export const AWS_FUNDING_STATUS_OPTIONS = [
  "Bootstrapped",
  "Pre-seed",
  "Seed funded",
  "Series A+",
  "Not applicable",
];

export const AWS_MONTHLY_SPEND_OPTIONS = [
  "Not yet on AWS",
  "Under $500",
  "$500 – $2,000",
  "$2,000 – $10,000",
  "$10,000+",
];
